import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { IAsyncData } from "../../../../core/models";
import { IAppReduxState } from "../../../../redux/store";
import { ROUTES } from "../../../../routes";
import { IProductSellBulkTransactionForm } from "../../data/product_sell_transaction_entity";
import { ProductSellTransactionForm } from "../components/product_sell_bulk_form";
import { transactionRedux } from "../state/state";

export const ProductSellTransactionCreatePage: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const onSubmit = async (values: IProductSellBulkTransactionForm): Promise<void> => {
    await dispatch(transactionRedux.actions.createBulk(values));
    history.push(ROUTES.transaction);
  };

  const createTransactionBranch = useSelector<IAppReduxState, IAsyncData<any>>((state) => state.transaction.createBulk);

  return (
    <ProductSellTransactionForm
      branch={createTransactionBranch}
      onSubmit={onSubmit}
      initialData={null}
      submitTitle="Create"
    />
  );
};
